<template>
  <div>
    <RouterView />
    <Toast />
    <ConfirmDialog />
    <Dialog
      :visible="errorsStore.networkError"
      class="bg-red-100"
      :closable="false"
      header="Erreur réseau"
    >
      <div>Une erreur réseau est survenue, veuillez rafraîchir la page</div>
      <div class="flex justify-center mt-4">
        <Button severity="danger" @click="() => router.go()">Rafraîchir</Button>
      </div>
    </Dialog>
    <Dialog
      :visible="errorsStore.deprecatedCodeError"
      class="bg-green-100"
      :closable="false"
      header="Mise à jour"
    >
      <div>L'application a été mise à jour, veuillez rafraîchir la page avec</div>
      <div class="flex justify-center mt-4">
        <pre>Ctrl + Shift + R</pre>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import { watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useErrorsStore } from './store/errors'

const route = useRoute()
const router = useRouter()

const errorsStore = useErrorsStore()

const updateFavicon = (iconPath) => {
  let link = document.querySelector("link[rel~='icon']")
  if (!link) {
    link = document.createElement('link')
    link.rel = 'icon'
    document.head.appendChild(link)
  }
  link.href = iconPath
}

const updateTitle = (title) => {
  document.title = title
}

// Change favicon on initial load
watch(
  () => route.path,
  (newPath) => {
    if (newPath.includes('/chat-monitor') || newPath.includes('/crisp-monitor')) {
      updateFavicon('/favicons/eye-solid.svg')
      updateTitle('Monitoring Crisp | Customer Care')
    } else if (newPath.includes('/chat')) {
      updateFavicon('/favicons/comments-solid.svg')
      updateTitle('Chat | Customer Care')
    } else if (newPath.includes('/conversations-stats')) {
      updateFavicon('/favicons/chart-simple-solid.svg')
      updateTitle('Stats | Customer Care')
    } else if (newPath.includes('/emails')) {
      updateFavicon('/favicons/envelope-solid.svg')
      updateTitle('Emails | Customer Care')
    } else if (newPath.includes('/conversation-monitor')) {
      updateFavicon('/favicons/eye-solid.svg')
      updateTitle('Monitoring Conversations | Customer Care')
    } else {
      updateFavicon('/favicons/favicon.ico')
      updateTitle('Customer Care | Deleev')
    }
  },
  { immediate: true },
)
</script>
